import { useCheckRole } from '@ospace/auth'
import { useCampaign } from '@ospace/campaign'
import { userTypes } from '@ospace/core-auth'
import { PageTitle } from '@ospace/layout'
import { ErrorBoundary, showNotification } from '@ospace/shared'
import { useMutation, useQueryClient } from 'react-query'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { ContactReviewTable } from '../components/ContactReviewTable'
import { ContactService } from '../services'

type Props = { campaignId: number }
export const ContactReviewPage = (props: Props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const { data: campaign } = useCampaign(props.campaignId)

  const mutation = useMutation(
    (contact: any) => {
      contact.campaignId = props.campaignId
      contact.lookerClientId = campaign?.lookerClientId
      return ContactService.processContact(contact)
    },
    {
      onSuccess: () => {
        showNotification({
          message:
            'You have successfully uploaded contacts and they are being processed. Please check back in a couple of minutes.',
          type: 'success',
        })
        navigate(`/campaign/${props.campaignId}/contact`)
        queryClient.refetchQueries(['contacts', props.campaignId])
      },
      onError: (e: any) => {
        showNotification({
          message: e.response?.data || e.message,
          type: 'error',
        })
      },
    }
  )

  return (
    <>
      <PageTitle>Upload Contacts</PageTitle>
      <div className='card'>
        <ContactReviewTable
          contacts={location?.state?.data}
          payload={location?.state?.payload}
          mutation={mutation}
        />
      </div>
    </>
  )
}

const Controller = () => {
  useCheckRole([userTypes.Admin, userTypes.ClientManager, userTypes.CampaignManager])
  const params: any = useParams()
  const campaignId = Number(params?.id)
  return <ContactReviewPage campaignId={campaignId} />
}

export const ContactReviewPageRouteHandler = () => (
  <ErrorBoundary>
    <Controller />
  </ErrorBoundary>
)
